import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Sheet } from '@mui/joy';

/** The «Gasbi AI» mark: the sparkles on a primary tile, before the name in every header. */
export const BrandTile = ({ size = 36 }: { size?: number }) => (
  <Sheet
    variant='solid'
    color='primary'
    sx={{
      width: size,
      height: size,
      borderRadius: size / 4.5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      fontSize: size / 1.8,
    }}
  >
    <AutoAwesomeIcon fontSize='inherit' />
  </Sheet>
);
